
<div class="d-flex align-items-end justify-content-end">
    <img (click)="back()" src="./assets/images/icon-circle-fail.png" alt="" height="30">
</div>
<div id="qr-reader" style="max-width:500px;width:80vw"></div>